import { catalogApi } from '@/store/api/catalog/catalog.api';
import type { TypeAppDispatch } from '@/store/store';
import type { TypeCatalogBundle, TypeCatalogItem } from '@/types/catalog/types.catalog';
import { dropById, upsertById } from '@/store/api/base/api.cache';

const byRecent = (a: { updatedAt: string }, b: { updatedAt: string }) => b.updatedAt.localeCompare(a.updatedAt);

export const writeItem = (dispatch: TypeAppDispatch, item: TypeCatalogItem) => {
    dispatch(catalogApi.util.updateQueryData('listCatalogItems', undefined, (draft) => {
        upsertById(draft, item);
        draft.sort(byRecent);
    }));
};

export const writeBundle = (dispatch: TypeAppDispatch, bundle: TypeCatalogBundle) => {
    dispatch(catalogApi.util.updateQueryData('listCatalogBundles', undefined, (draft) => {
        upsertById(draft, bundle);
        draft.sort(byRecent);
    }));
};

export const dropItem = (dispatch: TypeAppDispatch, id: string) => {
    dispatch(catalogApi.util.updateQueryData('listCatalogItems', undefined, (draft) => {
        dropById(draft, id);
    }));
};

export const dropBundle = (dispatch: TypeAppDispatch, id: string) => {
    dispatch(catalogApi.util.updateQueryData('listCatalogBundles', undefined, (draft) => {
        dropById(draft, id);
    }));
};
